import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module'; 
import { CompteUtilisateurComponent } from './compte-utilisateur.component';
import { MenuComponent } from './components/menu/menu.component';
import { UserMenuComponent } from './components/user-menu/user-menu.component';
import { FullScreenComponent } from './components/fullscreen/fullscreen.component'; 
import { MessagesComponent } from './components/messages/messages.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { LitigeComponent } from './litige/litige.component'; 
import { SinistreComponent } from './sinistre/sinistre.component';
import { ConstatComponent } from './constat/constat.component';
import { SinitreNewComponent } from './sinitre-new/sinitre-new.component';
import { AddconstatComponent, ShowContratComponent, ShowFileConstatComponent } from './addconstat/addconstat.component';
import { ShowconstatComponent, SignatureConstatComponent } from './showconstat/showconstat.component';
import { LitigeNewComponent } from './litige-new/litige-new.component';
import { NgxStarRatingModule } from "ngx-star-rating";
import { AuthentificationGuard } from '../services/guards/authentification.guard';
// import { NgxMaterialRatingModule } from "ngx-material-rating";

import { DetailsComponent } from './sinistre/details/details.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxSpinnerModule } from 'ngx-spinner';
import { StoreModule } from '@ngrx/store';  
import { EffectsModule } from '@ngrx/effects';
import { DashboardEffect } from '../state/dashboard.effect';
import { DashboardReducer } from '../state/dashboard.reducer';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { updateFileImageComponent } from './mes-vehicules/cars/showcar/showcar.component';
import { NgImageSliderModule } from 'ng-image-slider';
import { ViewPDFComponent } from './view-pdf/view-pdf.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxPaginationModule } from 'ngx-pagination';
import { RoleGuard } from '../services/guards/RoleGuard.guard';

export const routes = [ 
  { 
    path: '', 
    canActivate: [AuthentificationGuard],
    component: CompteUtilisateurComponent, children: [
      { path: 'litige', canActivate: [RoleGuard],component: LitigeComponent, data: { breadcrumb: 'Verification' }},
      { path: 'ajoute-litige', canActivate: [RoleGuard],component: LitigeNewComponent, data: { breadcrumb: 'Verification' }},
      { path: 'sinistre', canActivate: [RoleGuard],component: SinistreComponent, data: { breadcrumb: 'details sinistre' }},
      { path: 'details-sinistre', canActivate: [RoleGuard],component: DetailsComponent, data: { breadcrumb: 'Verification' }},

      { path: 'ajoute-sinistre', canActivate: [RoleGuard],component: SinitreNewComponent, data: { breadcrumb: 'Verification' }},
      { path: 'constat', canActivate: [RoleGuard],component: ConstatComponent, data: { breadcrumb: 'Constat' }},
      { path: 'ajoute-constat',canActivate: [RoleGuard], component: AddconstatComponent, data: { breadcrumb: 'Nouveau Constat' }},
       { path: 'voir-constat',canActivate: [RoleGuard], component: ShowconstatComponent, data: { breadcrumb: 'Info Constat' }},
      { path: '',canActivate: [RoleGuard], loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) }, 
      { path: 'mon-compte',canActivate: [RoleGuard], loadChildren: () => import('./mon-compte/mon-compte.module').then(m => m.MenuItemsModule),data: { breadcrumb: 'Mon Compte' } },
      { path: 'mes-vehicules',canActivate: [RoleGuard], loadChildren: () => import('./mes-vehicules/mes-vehicules.module').then(m => m.MenuItemsModule) },
      { path: 'mes-locations',canActivate: [RoleGuard], loadChildren: () => import('./mes-locations/mes-locations.module').then(m => m.MesLocationsModule) },
      { path: 'mes-paiements',canActivate: [RoleGuard], loadChildren: () => import('./mes-paiements/mes-paiements.module').then(m => m.MesPaiementsModule) },
      { path: 'mes-prolongations',canActivate: [RoleGuard], loadChildren: () => import('./mes-prolongations/mes-prolongations.module').then(m => m.MesProlongationsModule) },

      // { path: 'super', loadChildren: () => import('./super-admin/super-admin.module').then(m => m.MenuItemsModule) },

      
      { path: 'sales',canActivate: [RoleGuard], loadChildren: () => import('./sales/sales.module').then(m => m.SalesModule) },
      { path: 'users',canActivate: [RoleGuard], loadChildren: () => import('./users/users.module').then(m => m.UsersModule), data: { breadcrumb: 'Users' } },
      { path: 'reservations',canActivate: [RoleGuard], loadChildren: () => import('./reservations/reservations.module').then(m => m.ReservationsModule), data: { breadcrumb: 'Reservations' } },
      { path: 'customers',canActivate: [RoleGuard], loadChildren: () => import('./customers/customers.module').then(m => m.CustomersModule), data: { breadcrumb: 'Customers' } },
      { path: 'coupons',canActivate: [RoleGuard], loadChildren: () => import('./coupons/coupons.module').then(m => m.CouponsModule), data: { breadcrumb: 'Coupons' } },
      { path: 'withdrawal',canActivate: [RoleGuard], loadChildren: () => import('./withdrawal/withdrawal.module').then(m => m.WithdrawalModule), data: { breadcrumb: 'Withdrawal Requests' } },
      { path: 'analytics',canActivate: [RoleGuard], loadChildren: () => import('./analytics/analytics.module').then(m => m.AnalyticsModule), data: { breadcrumb: 'Analytics' } },
      { path: 'refund',canActivate: [RoleGuard], loadChildren: () => import('./refund/refund.module').then(m => m.RefundModule), data: { breadcrumb: 'Refund Requests' } },
      { path: 'followers',canActivate: [RoleGuard], loadChildren: () => import('./followers/followers.module').then(m => m.FollowersModule), data: { breadcrumb: 'Followers' } },
      { path: 'support',canActivate: [RoleGuard], loadChildren: () => import('./support/support.module').then(m => m.SupportModule), data: { breadcrumb: 'Support' } },
      { path: 'reviews',canActivate: [RoleGuard], loadChildren: () => import('./reviews/reviews.module').then(m => m.ReviewsModule), data: { breadcrumb: 'Reviews' } } ,
      { path: 'message',canActivate: [RoleGuard], loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule), data: { breadcrumb: 'Message' } } ,
    ]
  } 
];


@NgModule({
  declarations: [
    CompteUtilisateurComponent,
    MenuComponent,
    UserMenuComponent,
    FullScreenComponent,
    MessagesComponent,
    BreadcrumbComponent,
    LitigeComponent,
    ConstatComponent,
    SinistreComponent,
    SinitreNewComponent,
    AddconstatComponent,
    ShowconstatComponent,
    LitigeNewComponent,
    DetailsComponent,
    ShowFileConstatComponent,
    SignatureConstatComponent,
    updateFileImageComponent,
    ShowContratComponent,
    ViewPDFComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    NgxStarRatingModule,
    NgxSpinnerModule,
    NgxDropzoneModule,
    NgxPaginationModule,
    PdfViewerModule,
    NgImageSliderModule,
    EffectsModule.forFeature([DashboardEffect]),
    StoreModule.forFeature('dashboard', DashboardReducer),
    AngularSignaturePadModule 
  ],
})
export class CompteUtilisateurModule {}
